jQuery.noConflict();
jQuery(document).ready(function($) {
  $('.soff_browse_filter_select').change(function(event){
    event.preventDefault();
    window.location.replace($(this).find('option:selected').data('target'));
  });
  $('#soff_previous').change(function(event){
    window.location.replace($(this).data('target'));
  });
  $('.soff_status').change(function(e){
    if($('.soff_status_unsold').is(':checked') && $('.soff_status_sold').is(':checked')){
      $('input[name=soff_status]').val('');
    } else {
      if($('.soff_status_unsold').is(':checked')){
        $('input[name=soff_status]').val('unsold');
      }
      if($('.soff_status_sold').is(':checked')){
        $('input[name=soff_status]').val('sold');
      }
    }
    $('#soff_browse_filters_form').submit();
  });
});
